import { createContext, useContext } from 'react';

/**
 * Provided by WidgetFrame to the widget component and the shared templates.
 *
 * { entry, id, size, opts, mode, isMobile, inPreview, locked,
 *   setHeader(partial), reportStatus(key, status), unreportStatus(key),
 *   handleProps, onResizeGroup(group), onRemove(), onOpenSettings(anchorEl) }
 */
export const WidgetFrameContext = createContext(null);

export function useWidgetFrame() {
  return useContext(WidgetFrameContext);
}
